import { CarServiceBuilder } from './car-service-builder';
import { CarserviceFamily } from './../model/carservice-family';
export class CarServiceFamilyBuilder {
    static buildCarServiceFamily(data) {
        const carServiceFamily = new CarserviceFamily();
        carServiceFamily.id = data.id;
        carServiceFamily.name_es = data.name_es;
        carServiceFamily.name_ca = data.name_ca;
        carServiceFamily.name_en = data.name_en;
        carServiceFamily.name_fr = data.name_fr;
        carServiceFamily.icon = data.icon;
        carServiceFamily.sort = data.sort;
        carServiceFamily.visible_in_additional_block = data.visible_in_additional_block;
        carServiceFamily.visible_in_main_block = data.visible_in_main_block;
        carServiceFamily.has_carservice_logo = Boolean(+data.has_carservice_logo);
        carServiceFamily.car_services = data.car_services.map(carservice => CarServiceBuilder.buildCarService(carservice));
        return carServiceFamily;
    }
}
//# sourceMappingURL=car-service-family-builder.js.map